<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card no-body>
          <b-card-body>
            <template>
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="category_customer" label="Kategori Konsumen">
                    <model-select
                      id="category_customer"
                      :options="listCategoryCustomer"
                      v-model="category"
                      placeholder="-- Harap pilih salah satu --"
                      @input="setSelected"
                    ></model-select>
                    <div
                      v-if="category === null"
                      class="invalid-feedback-custom"
                    >Kategori harus di isi.</div>
                  </b-form-group>
                </b-col>
               
              </b-row>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <div class="card">
      <div class="card-header">Export Data Freezer</div>
      <div v-if="loading == true">
        <loading></loading>
      </div>
      <div class="card-body" v-if="loading == false">
        <div class="col-lg-3">
          <b-button type="button" size="sm" variant="primary" @click="downloadfile">
            <i class="fa fa-save"></i> Download
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loading from "@/templates/Loading.vue";
import { ModelSelect } from "vue-search-select";
import * as moment from "moment";

export default {
  name: "summary-sold-product",
  components: {
    loading,
    ModelSelect
  },
  data() {
    return {
      month: [
        { value: "01", text: "January" },
        { value: "02", text: "February" },
        { value: "03", text: "March" },
        { value: "04", text: "April" },
        { value: "05", text: "May" },
        { value: "06", text: "June" },
        { value: "07", text: "July" },
        { value: "08", text: "August" },
        { value: "09", text: "September" },
        { value: "10", text: "October" },
        { value: "11", text: "November" },
        { value: "12", text: "December" }
      ],
      listCategoryCustomer: [],
      listCompany: [],
      listMitraDC: [],
      others: null,
      year: [
        { value: "2019", text: "2019" },
        { value: "2020", text: "2020" }
      ],
      currentYear: moment().format("YYYY"),
      currentMonth: moment().format("MM"),
      listDateType: [
        { value: "1", text: "Retur" },
        { value: "2", text: "Aktual" },
      ],
      loading: false,
      category: null,
      myDate: null,
      othersParam: null,
      dateType: null
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.loading = false;
      this.getAllOthers();
    },
    downloadfile: function() {
      if (confirm("Are You Sure?")) {
        this.loading = true;
        if (this.others === null) {
          alert("Filter harus di isi");
        } else {
         
          this.axios({
            url: "web/export/asset/summary-freezer/" + this.category ,
            method: "GET",
            responseType: "blob"
          })
            .then(response => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "summary_freezer.xlsx");
              document.body.appendChild(link);
              link.click();
            })
            .catch(error => {
              if (error.response.status === 401) {
                this.expired(error, "");
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
    getAllOthers: function() {
      this.axios
        .get("web/dropdown/summary-freezer-report")
        .then(response => {
          this.listCategoryCustomer = response.data.customer_group;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    setSelected(event) {
        this.others = event;
    },
    expired: function(error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired"
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message
        });
      }
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
</style>
